import { on } from "svelte/events";
import { unmaskElement } from "./decodeMaskedRef.ts";
import { resolveOcAuto } from "./resolveOcAuto.ts";

if (typeof document !== "undefined") {
  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  ["focusin", "mouseover", "touchstart"].forEach((eventName) =>
    on(document.body, eventName, unmaskElement, { passive: true }),
  );

  /**
 *
 */
  on(document.body, "focusin", resolveOcAuto, { passive: true });
}
